export default {
  ar: "rtl",
  en: "ltr",
  br: "ltr",
  de: "ltr",
  es: "ltr",
  fr: "ltr",
  it: "ltr",
  pt: "ltr",
  ja: "ltr"
};
